import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const AboutUs1 = () => {
    useEffect(() => {
        AOS.init({
            duration: 900,
            easing: "ease-out-cubic",
            once: false,
        });
    }, []);

    return (
        <section id="features" className="py-5" style={{ backgroundColor: "#ffffff" }}>
            <div className="aboutOne text-center">
                {/* Tag */}
                <div
                    className="d-inline-block mb-3 px-3 py-1 rounded-pill border"
                    style={{
                        backgroundColor: "#ffffff",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                    }}
                    data-aos="fade-up"
                >
                    <span className="fw-bold text-dark">Welcome to Biblivium - Where Literature Lives.</span>
                </div>

                {/* Heading */}
                <h2
                    className="mb-3 fw-bold"
                    style={{ maxWidth: "700px", margin: "0 auto" }}
                    data-aos="fade-up"
                    data-aos-delay="100"
                >
                    We don’t aim to catalogue everything.
                    We aim to curate what matters.
                </h2>

                <div className="row py-5"
                    style={{
                        background: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #fff",
                        boxShadow:
                            "0px 2px 10px rgba(28,28,28,0.08), inset 0 -6px 6px rgba(255,255,255,0.2)",
                    }} >
                    <div className="col-md-6">
                        <img
                            src="/media/analysing.jpg"
                            alt="About Us"
                            className="img-fluid rounded-4 shadow-sm mb-4"
                            data-aos="zoom-in"
                            data-aos-delay="300"
                        />
                    </div>

                    <div className="col-md-6">

                        {/* Subtitle */}
                        <p
                            className="text-muted mb-2 py-5"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            Biblivium is a curated literary platform dedicated to exploring the world’s most meaningful works of literature-across languages, cultures, and time.
                        </p>
                        <p
                            className="text-muted mb-5"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            In an age of endless content and algorithm-driven discovery, truly important books are often lost behind noise, language barriers, or academic complexity. Biblivium was created to restore focus, context, and quiet depth to the act of literary discovery.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
